import { createClient } from '@supabase/supabase-js';
import { appConfig } from '../config/appConfig';

const url = appConfig.supabaseUrl;
const anonKey = appConfig.supabaseAnonKey;

if (!url || !anonKey) {
  throw new Error('supabaseUrl y supabaseAnonKey son requeridos (config montada en runtime o VITE_SUPABASE_* en .env)');
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    // Implicit flow: permite verifyOtp con 6 digitos sin PKCE code verifier.
    // Con PKCE (default), cada llamada a resetPasswordForEmail genera un nuevo
    // verifier que pisa el anterior, rompiendo el verify si el usuario reenvía.
    // TODO Fase 11: evaluar PKCE cuando haya SMTP real y flujo de magic link.
    flowType: 'implicit',
  },
});
